import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FragQueryService } from 'src/injectables/frag-query.service';

@Component({
    selector: 'timeline-chunk-selector',
    templateUrl: './timeline-chunk-selector.component.html',
    styleUrls: ['./timeline-chunk-selector.component.scss']
})
export class TimeLineChunkSelectorComponent {
    private _timeLineChunks: { [label: string]: number } = {};
    public timeLineChunkKeys: string[] = [];

    constructor(
        public readonly fragQuery: FragQueryService
    ) { }

    @Input()
    set timeLineChunks(chunks: { [label: string]: number }) {
        this._timeLineChunks = chunks;
        this.timeLineChunkKeys = Object.keys(this._timeLineChunks);
    }

    get timeLineChunks(): { [label: string]: number } {
        return this._timeLineChunks;
    }

    @Input() selectedTimeLineChunk!: number;
    @Output() timeLineChunkChanged = new EventEmitter<number>();

    public showTimeRangeButtons = true;

    public setTimeline(label: string) {
        this.fragQuery.chunkSizeSelectedByUser$.next(true)
        const minutes = this.timeLineChunks[label];
        this.timeLineChunkChanged.emit(minutes);
    }

    public isSelected(label: string): boolean {
        return this.selectedTimeLineChunk === this.timeLineChunks[label];
    }

    public handleTimeLineRangeRefresh(){
        this.fragQuery.chunkSizeSelectedByUser$.next(false)
        this.timeLineChunkChanged.emit(0);
    }
}